import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from './sub-components/Navbar';
import Hero from './sub-components/Hero';
import About from './sub-components/about';
import Contact from './sub-components/contact';
import CardsSection from './sub-components/CardsSection';

function LandingPage(props) {
  const location = useLocation();

  // After the page mounts, scroll to whatever section was requested via router state.
  // Using useEffect guarantees the DOM is fully rendered before we try to scroll.
  useEffect(() => {
    const target = location.state?.scrollTo;
    if (!target || target === 'hero') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }
    const el = document.getElementById(target);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  }, [location.state]);

  return (
    <div className="bg-[#0D0D0D] text-[#E0E0E0]">
      <Navbar
        SetActiveDocs={props.SetActiveDocs}
        activeSection={props.activeSection}
        setIsOpen={props.setIsOpen}
      />
      <Hero handler={props.handler} setIsOpen={props.setIsOpen} />
      <About handler={props.handler} />
      <CardsSection />
      <Contact handler={props.handler} />
    </div>
  );
}

export default LandingPage;
